export class ProvisionOutput {
  montantPret: number;
  impayeJour: number;
  resteAPayer: number;

  statutDossier: string;
  segmentationClient: string;

  encoursNonCouvert: number;
  totalGaranties: number;
  calculatedProvisions: number;
  ponderation: number;

  //private double encoursNonCouvertHorsBilan;
  montantGarantie: number;
  provisionNC: number;
  provisionPR: number;
  provisionTotale: number;
}
